export default {
  title: 'Payment',
  how: {
    title: 'How do I pay for my order?',
    description: 'A secure payment link will be sent to you via text message and email.',
  },
  payments: {
    title: 'Which payments do you accept?',
    description: 'We can only accept credit card payments at the moment. Supported cards include Visa, Mastercard, and American Express. Payment via ApplePay and GooglePay is possible as well for these cards.',
  },
  amount: {
    title: 'What does the amount charged consist of?',
    description: 'The amount charged for the prescription consists of: Cost of the medications prescribed + pharmacist dispensing fee + £2.50 delivery fee',
  },
};
